import ProjectsHero from "../components/Projects/ProjectsHero";
import StartProjects from "../components/Projects/StartProjects";
import OpeningSoon from "../components/Projects/OpeningSoon";
import InViewFade from "../components/Generic/InViewFade";

const Projects = () => {
  return (
    <div className="projects-page">
      <InViewFade direction="down">
        <ProjectsHero />
      </InViewFade>

      <InViewFade direction="right">
        <StartProjects />
      </InViewFade>

      <InViewFade direction="up">
        <OpeningSoon />
      </InViewFade>
    </div>
  );
};

export default Projects;
